/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Row_AgentInputs */

const en_cmp_row_agent = /** @type {(inputs: Cmp_Row_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works with any coding agent`)
};

const id_cmp_row_agent = /** @type {(inputs: Cmp_Row_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalan dengan agen coding apa pun`)
};

/**
* | output |
* | --- |
* | "Works with any coding agent" |
*
* @param {Cmp_Row_AgentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_row_agent = /** @type {((inputs?: Cmp_Row_AgentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Row_AgentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_row_agent(inputs)
	return en_cmp_row_agent(inputs)
});